import { render } from "./GrupoCreate.vue?vue&type=template&id=2034a30f&scoped=true"
import script from "./GrupoCreate.vue?vue&type=script&lang=js"
export * from "./GrupoCreate.vue?vue&type=script&lang=js"

import "./GrupoCreate.vue?vue&type=style&index=0&id=2034a30f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2034a30f"]])

export default __exports__